namespace TabAurous.Inventory {
    export interface ReOrderDetailsForm {
        TransId: Serenity.StringEditor;
        ProductTypeId: Serenity.LookupEditor;
        CategoryId: CommonCategoryLookup;
        SubCategoryId: Serenity.LookupEditor;
        ProductId: Serenity.StringEditor;
        UOM: Serenity.LookupEditor;
        AttributeId: Serenity.IntegerEditor;
        Minimum0: Serenity.DecimalEditor;
        Maximum0: Serenity.DecimalEditor;
        Minimum1: Serenity.DecimalEditor;
        Maximum1: Serenity.DecimalEditor;
        Minimum2: Serenity.DecimalEditor;
        Maximum2: Serenity.DecimalEditor;
        Validate: Serenity.BooleanEditor;
    }

    export class ReOrderDetailsForm extends Serenity.PrefixedContext {
        static formKey = 'Inventory.ReOrderDetails';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ReOrderDetailsForm.init)  {
                ReOrderDetailsForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.LookupEditor;
                var w2 = CommonCategoryLookup;
                var w3 = s.IntegerEditor;
                var w4 = s.DecimalEditor;
                var w5 = s.BooleanEditor;

                Q.initFormType(ReOrderDetailsForm, [
                    'TransId', w0,
                    'ProductTypeId', w1,
                    'CategoryId', w2,
                    'SubCategoryId', w1,
                    'ProductId', w0,
                    'UOM', w1,
                    'AttributeId', w3,
                    'Minimum0', w4,
                    'Maximum0', w4,
                    'Minimum1', w4,
                    'Maximum1', w4,
                    'Minimum2', w4,
                    'Maximum2', w4,
                    'Validate', w5
                ]);
            }
        }
    }
}
